import { computed } from "nanostores";

import { getKnowledgeBase, listKnowledgeBases } from "../api";
import { createPaginationStore } from "../stores/pagination.ts";
import { PaginationParams } from "../types/pagination.ts";
import { createApiStore } from "./api-store";
import { $router } from "./router";

export const $knowledgeBasePagination = createPaginationStore();

const $paginationParamsString = computed(
  $knowledgeBasePagination.$paginationParams,
  (params) => JSON.stringify(params),
);

export const $knowledgeBasesList = createApiStore(listKnowledgeBases, {
  mapToOptions: ([paginationParamsString]) => {
    const paginationParams: PaginationParams = paginationParamsString
      ? JSON.parse(paginationParamsString)
      : { currentPage: 1, pageSize: 10 };

    return {
      query: {
        currentPage: paginationParams.currentPage,
        pageSize: paginationParams.pageSize,
      },
    };
  },
  params: [$paginationParamsString],
  storeKey: "knowledgeBasesList",
});

// Store for loading a single knowledge base by ID
export const $knowledgeBaseContent = createApiStore(getKnowledgeBase, {
  mapToOptions: ([knowledgeBaseId]) => ({
    path: { id: knowledgeBaseId ?? "" },
  }),
  params: [
    computed($router, (router) => {
      if (!router?.params) return null;

      return "id" in router.params ? (router.params.id as string) : null;
    }),
  ],
  storeKey: "knowledgeBaseContent",
});
